function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 0a9 9 0 109 9 9 9 0 00-9-9z",
  fillRule: "evenodd",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 1.5A7.5 7.5 0 111.5 9 7.5 7.5 0 019 1.5M9 0a9 9 0 109 9 9 9 0 00-9-9z",
  fill: "#d0d0d0",
  fillRule: "evenodd"
});

var SvgNavCircle = function SvgNavCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref, _ref2);
};

export default SvgNavCircle;